import React from "react";
import useThemeHook from "../hooks/useThemeHook";
import { THEME_COLORS } from "../themes/DarkLight";
import { FONTSIZE } from "../../constants";

export default function Text({
  text,
  style,
  onPress,
}: {
  text: string | number;
  style: {};
  onPress?: any;
}) {
  const theme = useThemeHook();
  return (
    <p
      onClick={onPress}
      style={{
        maxLines: undefined,
        fontSize: FONTSIZE.QUATERNARY,

        ...style,
      }}
    >
      {text}
    </p>
  );
}
